<template>
  <va-form :id="id" :item="item">
    <v-row justify="center">
      <v-col sm="6">
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2">
              {{ title }}
            </div>
          </template>
          <v-card-text>
            <va-text-input source="vat" required></va-text-input>
            <va-text-input source="county" required></va-text-input>
            <va-text-input source="reg_number" required></va-text-input>
            <va-text-input source="web" required></va-text-input>
            <va-text-input source="phone" required></va-text-input>
            <va-text-input source="address" required></va-text-input>
            <va-text-input source="zip" required></va-text-input>
            <va-text-input source="fax" required></va-text-input>
            <va-text-input source="name" required></va-text-input>
            <va-text-input source="city" required></va-text-input>
            <va-text-input source="email" required></va-text-input>
          </v-card-text>
          <va-save-button></va-save-button>
        </base-material-card>
      </v-col>
    </v-row>
  </va-form>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
